import React from 'react'
import image from "../../Asset/feature/image.png";

const Branchimage = () => {
  return (
    <div className='w-full'>
      <img src={image} className='w-full object-cover'/>
      
    </div>
  )
}

export default Branchimage
